import {useEffect} from 'react'
import {graphql, useFragment} from 'react-relay'

import {fetchProjectWithAllParentsData} from '../../../actions/projects'
import {useAppDispatch} from '../../../hooks/react-redux'
import useMyId from '../../../hooks/useMyId'
import type {ProjectId} from '../../../types'
import {createRefetchableSubscription} from '../../../utils/refetchable'
import {
  getProjectSuffix,
  getTopic,
  getUserSuffix,
  subscribeOnOverallEvents,
} from '../../../utils/subscriber'
import {PROJECT_UPDATED, USER_PERMISSIONS_CHANGED} from '../../../utils/subscriptionEvents'

import type {ProjectPageFragment$key} from './__generated__/ProjectPageFragment.graphql'

const fragment = graphql`
  fragment ProjectPageFragment on ProjectRest {
    internalId
  }
`

export function useRefetchProject(
  projectId: ProjectId,
  projectKey: ProjectPageFragment$key | null,
) {
  const myId = useMyId()
  const {internalId} = useFragment(fragment, projectKey) ?? {}
  const dispatch = useAppDispatch()
  useEffect(
    () =>
      internalId != null && myId != null
        ? createRefetchableSubscription(
            () => dispatch(fetchProjectWithAllParentsData(projectId)),
            handler =>
              subscribeOnOverallEvents(
                [
                  getTopic(PROJECT_UPDATED, getProjectSuffix(internalId)),
                  getTopic(USER_PERMISSIONS_CHANGED, getUserSuffix(myId)),
                ],
                handler,
              ),
          )
        : undefined,
    [dispatch, internalId, myId, projectId],
  )
}
